/** Text-only bindings for the app shell, whose elements live until page unload. */
export class TextBindings {
  private readonly elements = new Map<string, HTMLElement>();

  constructor(private readonly root: ParentNode) {}

  set(selector: string, value: string): void {
    let element = this.elements.get(selector);
    if (!element) {
      const found = this.root.querySelector<HTMLElement>(selector);
      if (!found) throw new Error(`Missing required element: ${selector}`);
      element = found;
      this.elements.set(selector, element);
    }
    // textContent does not force layout. Read the actual value because other
    // controllers may reset shell text between runs; a cached string can lie.
    if (element.textContent !== value) element.textContent = value;
  }
}
